
class ScrollLockManager {
  static get instance() {
    /* eslint-disable no-underscore-dangle */
    if (!window.__seqScrollLockManager) {
      window.__seqScrollLockManager = new ScrollLockManager('singleton');
    }

    return window.__seqScrollLockManager;
    /* eslint-enable no-underscore-dangle */
  }

  keys = new Set();

  isLocked = false;

  scrollTop = 0;

  scrollingElement = undefined; // added in init

  constructor(string) {
    this.init();

    if (string !== 'singleton') throw new Error('Cannot construct singleton');
  }

  init() {
    this.scrollingElement = document.scrollingElement
      ? document.scrollingElement
      : document.documentElement;
  }

  /**
   * Lock body scroll using a key to identify and log request to lock
   *
   * @param key any object or primitive to register the lock against, use the same key to release
   */
  lock = (key) => {
    if (!this.keys.has(key)) {
      this.keys.add(key);
    }

    if (!this.isLocked) {
      this.lockBodyScroll();
    }
  };

  /**
   * Release body scroll using a key to identify request against a previous lock
   *
   * @param key any object or primitive to identify the release against, use the same key as used when locking
   */
  release = (key) => {
    if (this.isLocked) {
      if (this.keys.has(key)) {
        this.keys.delete(key);
      }

      if (this.keys.size === 0) {
        this.releaseBodyScroll();
      }
    }
  };

  lockBodyScroll() {
    this.isLocked = true;
    this.scrollTop = this.scrollingElement.scrollTop;
    document.body.style.height = '100%';
    document.body.scrollTop = this.scrollTop;
  }

  releaseBodyScroll() {
    this.isLocked = false;
    document.body.style.height = '';
    document.body.scrollTop = 0;
    this.scrollingElement.scrollTop = this.scrollTop;
  }
}

export default ScrollLockManager.instance;
